import { useEffect, useRef } from 'react';
import { useScanningStatusSSE } from '../../hooks/useScanningStatusSSE';
import { saveExecutionFile } from '../../utils/api/executionFileApis';
import { STATUS } from '../../utils/api/sharedfunction';

const ScanFileWatcher = ({ file, folderIdFallback, onUpdate }) => {
  const finalizingRef = useRef(false);
  const enabled =
    file.scannedStatus === 'SCANNING' &&
    typeof file.fileKey === 'string' &&
    file.fileKey.includes('quarantine');

  const { scannedStatus, isScanningComplete } = useScanningStatusSSE(file.fileKey, enabled);

  useEffect(() => {
    if (!isScanningComplete || finalizingRef.current) return;

    const applyStatus = async () => {
      finalizingRef.current = true;

      if (scannedStatus === 'CLEAN') {
        try {
          const res = await saveExecutionFile({
            executionFileId: file.id,
            tempFileKey: file.fileKey,
            folderId: file.folderId || folderIdFallback,
            fileName: file.fileName,
            fileDescription: file.fileDescription || undefined,
            fileMetadata: file.fileMetadata || undefined,
          });
          if (res.status === STATUS.SUCCESS && res.data) {
            onUpdate(file.id, { ...res.data, scannedStatus: 'CLEAN' });
          } else {
            onUpdate(file.id, { scannedStatus: 'ERROR' });
          }
        } catch {
          onUpdate(file.id, { scannedStatus: 'ERROR' });
        }
        return;
      }

      onUpdate(file.id, { scannedStatus });
    };

    applyStatus();
  }, [scannedStatus, isScanningComplete, file.id, file.fileKey, file.folderId, file.fileName, file.fileDescription, file.fileMetadata, folderIdFallback, onUpdate]);

  return null;
};

const ScanningFilesMonitor = ({ files, selectedFolderId, onUpdate }) => {
  const scanningFiles = files.filter(
    (f) =>
      f.scannedStatus === 'SCANNING' &&
      typeof f.fileKey === 'string' &&
      f.fileKey.includes('quarantine'),
  );

  return scanningFiles.map((file) => (
    <ScanFileWatcher
      key={file.id}
      file={file}
      folderIdFallback={selectedFolderId}
      onUpdate={onUpdate}
    />
  ));
};

export default ScanningFilesMonitor;
